import { useMemo } from 'react';

export const useVersion = () => {
  const version = useMemo(() => {
    return __APP_VERSION__ ?? 'unknown';
  }, []);

  return { version };
};
